<template>
	<div class="cars-menu">
		<v-menu
			v-if="isDesktop"
			v-model="isMenuOpen"
			:open-delay="0"
			:close-delay="20"
			content-class="cars-menu-overlay"
			location="bottom start"
			:close-on-content-click="false"
			scroll-strategy="close"
			transition="scroll-y-transition"
			:offset="-5"
			open-on-hover
			:z-index="2051">
			<template #activator="{ props }">
				<NuxtLink
					v-bind="props"
					:to="carsLink"
					:prefetch="false"
					class="nav__item nav__item--dropdown"
					:class="{ 'nav__item--active': isCurrentRoute }">
					<span>{{ i18nService.$tDynamic('components.nav', item.translation_key_label) }}</span>
					<GlobalIcon
						name="arrow-down"
						:height="18"
						class="cars-menu__icon"
						:class="{ 'cars-menu__icon--expanded': props['aria-expanded'] === 'true' }" />
				</NuxtLink>
			</template>
			<Transition name="cars-menu-fade">
				<div v-show="isMenuOpen" class="cars-menu-overlay__dropdown" @mouseleave="isMenuOpen = false">
					<div class="cars-menu-overlay__title">
						{{ $t('modules.cars_module.cars.filters.vehicle_category') }}
					</div>
					<div class="cars-menu-overlay__links">
						<NuxtLink
							v-for="group in groups"
							:key="group.id"
							:to="linkForGroup(group)"
							:prefetch="false"
							class="cars-menu-overlay__link"
							@click="isMenuOpen = false">
							{{ i18nService.$tDynamic('data.group_map_translations', groupMapTranslations[group.name]) }}
						</NuxtLink>
					</div>
				</div>
			</Transition>
		</v-menu>
	</div>
</template>

<script setup lang="ts">
const componentProps = defineProps<{
	item: {
		translation_key_label: string
		to: string
		type: string
	}
}>()

const localePath = useLocalePath()
const route = useRoute()
const { isDesktop } = useWindowWidth()
const carsStore = useCarsStore()
const i18nService = usei18nService()

const isMenuOpen = ref(false)

const carsLink = computed(() => localePath(componentProps.item.to))
const isCurrentRoute = computed(() => componentProps.item.to === route.name?.slice(0, -5))

const groups = computed<IProductGroupModel[]>(() => filterPublicGroups(carsStore.getAllGroups ?? []))

const linkForGroup = (group: IProductGroupModel) => localePath({ name: 'cars', query: { group: group.name } })

onMounted(() => {
	carsStore.fetchAllGroups().catch((error: unknown) => logger.error(error))
})
</script>

<style lang="scss" src="./CarsMenu.scss"></style>
<style lang="scss">
.cars-menu-fade-enter-active {
	transition:
		transform 0.1s ease-out,
		opacity 0.1s ease-out;
}

.cars-menu-fade-leave-active {
	transition:
		transform 0.1s ease-in,
		opacity 0.1s ease-in;
}

.cars-menu-fade-enter-from,
.cars-menu-fade-leave-to {
	transform: translateY(-8px);
	opacity: 0;
}
</style>
